import type {
  ClientToolExecution,
  HarnessPendingToolCall,
} from '@/apis/assistant'
import type { ClientToolDefinition } from '@/apis/assistant/tool-executors'
import {
  CLIENT_TOOL_REGISTRY,
  executeClientTool,
} from '@/apis/assistant/tool-executors'

/** 查询前端 Tool 的卡片定义，用于决定消息形态、ID 前缀与失败文案。 */
export function getClientToolDefinition(
  name: string
): ClientToolDefinition | undefined {
  return CLIENT_TOOL_REGISTRY[name]
}

/** 执行注册表中的前端 Tool；未注册的 Tool 由 API 层给出既有错误。 */
export function runClientTool(
  toolCall: HarnessPendingToolCall
): Promise<ClientToolExecution> {
  return executeClientTool(toolCall)
}
